import { render, staticRenderFns } from "./MissedCallsList.vue?vue&type=template&id=ae853e9e&"
import script from "./MissedCallsList.vue?vue&type=script&lang=js&"
export * from "./MissedCallsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports